import ProfileLocked from "@components/templates/Profile/ProfileLocked";
import IntelLayout from "@components/layout/layout";
import { useState } from "react";

const SampleTradeLane = () => {
  const [showNotification, setShowNotification] = useState(false);
  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"tradeLaneProfileLocked"}>
      <ProfileLocked key="Trade Lane Profile" countries="Intel Enterprise Logistics" heading="Explore Trade Lane Profiles to get Comprehensive Insights into the Ports, Logistics Companies, and Importers/Exporters associated with them" imgUrl="v1712221274/intel/icons/tradelane_profile_emptystate_lka1vx.svg" profileName="Trade Lane" />
    </IntelLayout>
  );
};

export default SampleTradeLane;
